import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { LeadService } from 'src/app/services/lead.service';
import { ErrorUpdatingAction } from '../../actions';
import { InvestmentOptionsListRequestAction, InvestmentOptionsListResponseAction, SaveInvestmentOptionsRequestAction, SaveInvestmentOptionsResponseActions } from './actions';
import { InvestmentsService } from 'src/app/services/investments.service';

@Injectable()
export class NmjInvestmentsEffects {
    constructor(private store: Store<any>,
        private actions$: Actions,
        private leadService: LeadService,
        private investmentService: InvestmentsService) {
    }

    saveOptions$ = createEffect(() => this.actions$.pipe(
        ofType(SaveInvestmentOptionsRequestAction),
        switchMap((action: any) => this.leadService.update(action.step, action.field, action.data).pipe(
            map((data: any) => {
                this.leadService.showOk(data.message);
                return SaveInvestmentOptionsResponseActions();
            }),
            catchError(_err => {
                return of(ErrorUpdatingAction());
            })
        )),
    ));

    getInvestmentOptions$ = createEffect(() => this.actions$.pipe(
        ofType(InvestmentOptionsListRequestAction),
        switchMap((_action: any) => this.investmentService.getInvestmentOptions().pipe(
            map((data: any) => {
                this.investmentService.showOk(data.message);
                return InvestmentOptionsListResponseAction({ investmentOptions: data.data });
            }),
            catchError(_err => {
                return of(ErrorUpdatingAction());
            })
        )),
    ));
}
